import { useParams } from 'react-router-dom';

import { Toast, useToast } from '@zillow/constellation-10';

import { useRentalManagerUserPropertyMultiEditWebApiHandler_multi } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

const useGuardedMultiEdit = () => {
  const { propertyId } = useParams<{ propertyId: string }>();
  const { enqueueToast } = useToast();
  const { mutateAsync: saveMultipleFieldsPropertyInfoMutate } =
    useRentalManagerUserPropertyMultiEditWebApiHandler_multi();

  const saveMultipleFieldsPropertyInfo = (args: Parameters<typeof saveMultipleFieldsPropertyInfoMutate>[0]) => {
    if (!args?.postData?.property?.listingAlias) {
      if (!propertyId) {
        enqueueToast(<Toast tone="critical">Could not send your request, try again later</Toast>);
        return Promise.resolve();
      }
      args.postData.property.listingAlias = propertyId;
    }
    return saveMultipleFieldsPropertyInfoMutate(args);
  };

  return { saveMultipleFieldsPropertyInfo };
};

export default useGuardedMultiEdit;
